import {makeAutoObservable, runInAction} from 'mobx';
import {fetchCartItems} from '../http/cartAPI';
import {readGuestCart} from '../util/guestCart';

function sumPieces(lines) {
    return (lines || []).reduce((s, i) => s + Number(i.itemCount || 0), 0);
}

export default class CartStore {
    /** Суммарное количество единиц товара в корзине (для бейджа). */
    totalPieces = 0;

    /** Строки корзины (гость: itemId; авторизованный: id товара в поле id). */
    lines = [];

    constructor() {
        makeAutoObservable(this);
    }

    /**
     * Количество единиц товара `itemId` в корзине (для карточек каталога).
     */
    qtyForItem(itemId) {
        const pid = Number(itemId);
        if (Number.isNaN(pid)) return 0;
        const line = this.lines.find((l) => Number(l.itemId ?? l.id) === pid);
        return line ? Number(line.itemCount || 0) : 0;
    }

    /**
     * Синхронизирует счётчик с сервером или гостевой корзиной.
     * @param {boolean} isAuth
     */
    setTotalFromLines(lines) {
        runInAction(() => {
            this.lines = Array.isArray(lines) ? lines : [];
            this.totalPieces = sumPieces(this.lines);
        });
    }

    async refreshTotals(isAuth) {
        try {
            let lines = [];
            if (isAuth) {
                lines = await fetchCartItems();
            } else {
                lines = readGuestCart();
            }
            runInAction(() => {
                this.lines = Array.isArray(lines) ? lines : [];
                this.totalPieces = sumPieces(this.lines);
            });
        } catch {
            runInAction(() => {
                this.lines = [];
                this.totalPieces = 0;
            });
        }
    }
}
